// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b558df89","952":"646fb166"}[chunkId] + ".chunk.js";
};